var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("card", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row mt-4 my-2" }, [
      _c(
        "div",
        { staticClass: "col-12 my-2" },
        [
          _vm._l(_vm.formfiltersettings, function (formfiltersetting, findex) {
            return _c("div", [
              _c(
                "div",
                { staticClass: "shadow p-3 mb-5 bg-white rounded" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "badge badge-primary text-wrap",
                      staticStyle: { width: "2rem" },
                    },
                    [_vm._v(" NO " + _vm._s(findex + 1) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger float-right",
                      staticStyle: {
                        padding: "2px",
                        "padding-right": "8px",
                        "padding-left": "8px",
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.deleteFormFilterSetting(findex)
                        },
                      },
                    },
                    [_vm._v("Delete")]
                  ),
                  _c("div", { staticClass: "row mt-4 my-2" }, [
                    _c("div", { staticClass: "form-group col-5" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("__ExternalapiName"))),
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: formfiltersetting.externalapiname,
                              expression: "formfiltersetting.externalapiname",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                formfiltersetting,
                                "externalapiname",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(_vm.allExternalApiName, function (value, index) {
                          return _c(
                            "option",
                            {
                              key: "externalapiname-" + index,
                              domProps: { value: value },
                            },
                            [_vm._v(" " + _vm._s(value) + " ")]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c("div", { staticClass: "form-group col-5" }, [
                      _c("label", [_vm._v("App")]),
                      false
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "col-6 mb-0",
                                  attrs: { id: "appId-" + findex + "-title" },
                                },
                                [_vm._v(_vm._s(formfiltersetting.appid))]
                              ),
                              _c(
                                "span",
                                {
                                  attrs: { appid: "appId-" + findex + "-edit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editUI("appId-" + findex)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-pencil-alt cursor-pointer pl-1",
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: formfiltersetting.appid,
                            expression: "formfiltersetting.appid",
                          },
                        ],
                        staticClass: "form-control element-hide",
                        attrs: {
                          type: "text",
                          id: "appId-" + findex + "-input",
                        },
                        domProps: { value: formfiltersetting.appid },
                        on: {
                          keypress: function ($event) {
                            return _vm.confirmUIChangeKey(
                              $event,
                              "appId-" + findex
                            )
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              formfiltersetting,
                              "appid",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: formfiltersetting.appid,
                              expression: "formfiltersetting.appid",
                            },
                          ],
                          staticClass: "form-control col-7",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                formfiltersetting,
                                "appid",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(_vm.externals, function (external) {
                          return _c(
                            "option",
                            { domProps: { value: external.app_id } },
                            [_vm._v(_vm._s(external.app_name))]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "row mt-4 my-2" }, [
                    _c("label", { staticClass: "col-3" }, [
                      _vm._v(_vm._s(_vm.$t("__FilterType"))),
                    ]),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: formfiltersetting.filtertype,
                            expression: "formfiltersetting.filtertype",
                          },
                        ],
                        staticClass: "form-control col-7",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              formfiltersetting,
                              "filtertype",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "and" } }, [
                          _vm._v("and"),
                        ]),
                        _c("option", { attrs: { value: "or" } }, [
                          _vm._v("or"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "row mb-2 align-items-center" }, [
                    _c("div", { staticClass: "row col-6 my-2" }, [
                      _c("p", { staticClass: "col-9 my-4" }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("__FilterField")))]),
                      ]),
                    ]),
                    _c("div", { staticClass: "ml-1" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-info m-1",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              return _vm.addFilterFiled(findex)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-plus text-info" })]
                      ),
                    ]),
                  ]),
                  _vm._l(
                    formfiltersetting.filterFiledsObjectlize,
                    function (filterField, index) {
                      return _c(
                        "div",
                        {
                          key: findex + "-filter-" + index,
                          staticClass: "row",
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: filterField.fieldType,
                                  expression: "filterField.fieldType",
                                },
                              ],
                              staticClass: "form-control col-3 ml-3",
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      filterField,
                                      "fieldType",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "",
                                    disabled: "",
                                    selected: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("__filterTypeSelectOptional"))
                                  ),
                                ]
                              ),
                              _c("option", { attrs: { value: "date" } }, [
                                _vm._v(_vm._s(_vm.$t("__dateType"))),
                              ]),
                              _c("option", { attrs: { value: "dateRange" } }, [
                                _vm._v(_vm._s(_vm.$t("__dateRange"))),
                              ]),
                              _c("option", { attrs: { value: "dataSource" } }, [
                                _vm._v(_vm._s(_vm.$t("__dataSource"))),
                              ]),
                              _c("option", { attrs: { value: "dataJoin" } }, [
                                _vm._v(_vm._s(_vm.$t("__DataJoin"))),
                              ]),
                              _c("option", { attrs: { value: "dataCustom" } }, [
                                _vm._v(_vm._s(_vm.$t("__Custom"))),
                              ]),
                              _c("option", { attrs: { value: "liffUser" } }, [
                                _vm._v(_vm._s(_vm.$t("__LIFF_USER"))),
                              ]),
                            ]
                          ),
                          filterField.fieldType == "dataSource"
                            ? _c("div", { staticClass: "col-6 ml-3 mr-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col" }, [
                                    _vm._v("APP ID"),
                                  ]),
                                  _c("div", { staticClass: "col" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.filterFiled.app_id,
                                            expression: "filterFiled.app_id",
                                          },
                                        ],
                                        staticClass: "form-control col-7",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.filterFiled,
                                              "app_id",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      _vm._l(
                                        _vm.externals,
                                        function (external) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: {
                                                value: external.app_id,
                                              },
                                            },
                                            [_vm._v(_vm._s(external.app_name))]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col" }, [
                                    _vm._v("篩選欄位"),
                                  ]),
                                  _c("div", { staticClass: "col" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.filterFiled.filterField,
                                            expression:
                                              "filterFiled.filterField",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.filterFiled,
                                              "filterField",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "",
                                              disabled: "",
                                              selected: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "__UserVariableSelectOptional"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.allVariables,
                                          function (value, index) {
                                            return _c(
                                              "option",
                                              {
                                                key: "variable-" + index,
                                                domProps: { value: value },
                                              },
                                              [_vm._v(_vm._s(value))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col" }, [
                                    _vm._v("顯示欄位"),
                                  ]),
                                  _c("div", { staticClass: "col" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.filterFiled.displayField,
                                            expression:
                                              "filterFiled.displayField",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.filterFiled,
                                              "displayField",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "",
                                              disabled: "",
                                              selected: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "__UserVariableSelectOptional"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.allVariables,
                                          function (value, index) {
                                            return _c(
                                              "option",
                                              {
                                                key: "variable-" + index,
                                                domProps: { value: value },
                                              },
                                              [_vm._v(_vm._s(value))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]),
                              ])
                            : filterField.fieldType == "dataCustom"
                            ? _c(
                                "div",
                                { staticClass: "col-6 ml-3 mr-3" },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "card",
                                        staticStyle: { width: "100%" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "card-header row",
                                              },
                                              [
                                                _vm._v(" 欄位名稱 "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        filterField.customForm
                                                          .displayName,
                                                      expression:
                                                        "filterField.customForm.displayName",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      filterField.customForm
                                                        .displayName,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        filterField.customForm,
                                                        "displayName",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "card-header row",
                                              },
                                              [
                                                _vm._v(" 欄位類型 "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          filterField.customType,
                                                        expression:
                                                          "filterField.customType",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            filterField,
                                                            "customType",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                        function ($event) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      { attrs: { value: "" } },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "__pleaseEnter"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value: "fixvalue",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("__Fixvalue")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value: "dropdown",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("__dropdown")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value: "checkbox",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("__checkbox")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col" },
                                                    [_vm._v("欄位id")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col" },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                filterField
                                                                  .customForm
                                                                  .variable,
                                                              expression:
                                                                "filterField.customForm.variable",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.$set(
                                                                  filterField.customForm,
                                                                  "variable",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            ],
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "",
                                                                disabled: "",
                                                                selected: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "__UserVariableSelectOptional"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            _vm.allVariables,
                                                            function (
                                                              value,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key:
                                                                    "variable-" +
                                                                    index,
                                                                  domProps: {
                                                                    value:
                                                                      value,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      value
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col" },
                                                    [_vm._v("欄位類型")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col" },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                filterField
                                                                  .customForm
                                                                  .type,
                                                              expression:
                                                                "filterField.customForm.type",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.$set(
                                                                  filterField.customForm,
                                                                  "type",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            ],
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                selected: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "選擇欄位類型"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "input",
                                                              },
                                                            },
                                                            [_vm._v("input")]
                                                          ),
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  "checkbox",
                                                              },
                                                            },
                                                            [_vm._v("checkbox")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col" },
                                                    [_vm._v("欄位值")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col" },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              filterField
                                                                .customForm
                                                                .value,
                                                            expression:
                                                              "filterField.customForm.value",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value:
                                                            filterField
                                                              .customForm.value,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              filterField.customForm,
                                                              "value",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              filterField.customForm.type ==
                                              "checkbox"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "card-header row",
                                                    },
                                                    [
                                                      _vm._v(" 預設勾選 "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              filterField
                                                                .customForm
                                                                .defaultCheck,
                                                            expression:
                                                              "filterField.customForm.defaultCheck",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            Array.isArray(
                                                              filterField
                                                                .customForm
                                                                .defaultCheck
                                                            )
                                                              ? _vm._i(
                                                                  filterField
                                                                    .customForm
                                                                    .defaultCheck,
                                                                  null
                                                                ) > -1
                                                              : filterField
                                                                  .customForm
                                                                  .defaultCheck,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                filterField
                                                                  .customForm
                                                                  .defaultCheck,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  _vm.$set(
                                                                    filterField.customForm,
                                                                    "defaultCheck",
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ])
                                                                  )
                                                              } else {
                                                                $$i > -1 &&
                                                                  _vm.$set(
                                                                    filterField.customForm,
                                                                    "defaultCheck",
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      )
                                                                  )
                                                              }
                                                            } else {
                                                              _vm.$set(
                                                                filterField.customForm,
                                                                "defaultCheck",
                                                                $$c
                                                              )
                                                            }
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-header row",
                                                },
                                                [
                                                  _vm._v(" 同時尋找空白資料 "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          filterField.customForm
                                                            .emptyInclude,
                                                        expression:
                                                          "filterField.customForm.emptyInclude",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        filterField.customForm
                                                          .emptyInclude
                                                      )
                                                        ? _vm._i(
                                                            filterField
                                                              .customForm
                                                              .emptyInclude,
                                                            null
                                                          ) > -1
                                                        : filterField.customForm
                                                            .emptyInclude,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            filterField
                                                              .customForm
                                                              .emptyInclude,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                filterField.customForm,
                                                                "emptyInclude",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                filterField.customForm,
                                                                "emptyInclude",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            filterField.customForm,
                                                            "emptyInclude",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._l(
                                    filterField.customItems,
                                    function (customItem, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: "customItem-" + index,
                                          staticClass: "row",
                                        },
                                        [
                                          _c("div"),
                                          _c("div", { staticClass: "col" }),
                                          _c("div", { staticClass: "col" }, [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: customItem.filterValue,
                                                  expression:
                                                    "customItem.filterValue",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: { type: "text" },
                                              domProps: {
                                                value: customItem.filterValue,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    customItem,
                                                    "filterValue",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : filterField.fieldType == "dataJoin"
                            ? _c("div", { staticClass: "col-6 ml-3 mr-3" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card",
                                      staticStyle: { width: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "card-header row" },
                                        [
                                          _c("div", { staticClass: "col-5" }, [
                                            _vm._v(" 欄位名稱 "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    filterField.dataJoin
                                                      .displayName,
                                                  expression:
                                                    "filterField.dataJoin.displayName",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: { type: "text" },
                                              domProps: {
                                                value:
                                                  filterField.dataJoin
                                                    .displayName,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    filterField.dataJoin,
                                                    "displayName",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "card-header row" },
                                        [
                                          _c("div", { staticClass: "col-5" }, [
                                            _vm._v(" 欄位類型 "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      filterField.dataJoin.type,
                                                    expression:
                                                      "filterField.dataJoin.type",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        filterField.dataJoin,
                                                        "type",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  ],
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { attrs: { value: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("__pleaseEnter")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: { value: "isapply" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("__IsApply")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "card-header row" },
                                        [
                                          _c("div", { staticClass: "col-5" }, [
                                            _vm._v(" Join APP "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      filterField.dataJoin
                                                        .app_id,
                                                    expression:
                                                      "filterField.dataJoin.app_id",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control col-7",
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      filterField.dataJoin,
                                                      "app_id",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                _vm.externals,
                                                function (external) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: external.app_id,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          external.app_name
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]),
                                          _c("div", { staticClass: "col-5" }, [
                                            _vm._v(" Join 欄位 "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      filterField.dataJoin
                                                        .joinField,
                                                    expression:
                                                      "filterField.dataJoin.joinField",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      filterField.dataJoin,
                                                      "joinField",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "",
                                                      disabled: "",
                                                      selected: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "__UserVariableSelectOptional"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._l(
                                                  _vm.allVariables,
                                                  function (value, index) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key:
                                                          "variable-" + index,
                                                        domProps: {
                                                          value: value,
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(value))]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "card-body" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addDataJoinFilter(
                                                    filterField
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("新增條件")]
                                          ),
                                          _vm._l(
                                            filterField.dataJoin.filters,
                                            function (joinFilter, index) {
                                              return _c(
                                                "div",
                                                { key: "joinFilter-" + index },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-2",
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("比較欄位"),
                                                          ]),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    joinFilter.field,
                                                                  expression:
                                                                    "joinFilter.field",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal =
                                                                      Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                    _vm.$set(
                                                                      joinFilter,
                                                                      "field",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "",
                                                                    disabled:
                                                                      "",
                                                                    selected:
                                                                      "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "__UserVariableSelectOptional"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._l(
                                                                _vm.allVariables,
                                                                function (
                                                                  value,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key:
                                                                        "variable-" +
                                                                        index,
                                                                      domProps:
                                                                        {
                                                                          value:
                                                                            value,
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          value
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-2",
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("欄位類型"),
                                                          ]),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    joinFilter.type,
                                                                  expression:
                                                                    "joinFilter.type",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal =
                                                                      Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                    _vm.$set(
                                                                      joinFilter,
                                                                      "type",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "選擇欄位類型"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "input",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "input"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "checkbox",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "checkbox"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-2",
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("條件式"),
                                                          ]),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    joinFilter.operator,
                                                                  expression:
                                                                    "joinFilter.operator",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                "aria-placeholder":
                                                                  _vm.$t(
                                                                    "__fontcolor"
                                                                  ),
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal =
                                                                      Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                    _vm.$set(
                                                                      joinFilter,
                                                                      "operator",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "exactly_match",
                                                                    selected:
                                                                      "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__ExactlyMatch"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "fuzzy_match",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__FuzzyMatch"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "has_value",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__segmentcondition"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "no_value",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__segmentnocondition"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "no_exist",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__segmentnoexist"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "num_range",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__NumberRange"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "num_gt",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__GreaterThanNumber"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "num_lt",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__LessThanNumber"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "date_range",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__DataRange"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "datetime_range",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__DatatimeRange"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "short_link",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__shortLink"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "auto_reply_comments",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__autoReplyComments"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "auto_reply_live_mention",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__autoReplyLiveMention"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      "auto_reply_media",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "__autoReplyMedia"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      joinFilter.operator !=
                                                        "no_value" &&
                                                      joinFilter.operator !=
                                                        "has_value"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-2",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "比較值"
                                                                ),
                                                              ]),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      joinFilter.value,
                                                                    expression:
                                                                      "joinFilter.value",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control",
                                                                attrs: {
                                                                  type: "text",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    joinFilter.value,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.$set(
                                                                        joinFilter,
                                                                        "value",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      joinFilter.operator !=
                                                        "no_value" &&
                                                      joinFilter.operator !=
                                                        "has_value"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-2",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "同時尋找空白資料"
                                                                ),
                                                              ]),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      joinFilter.emptyInclude,
                                                                    expression:
                                                                      "joinFilter.emptyInclude",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control",
                                                                attrs: {
                                                                  type: "checkbox",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    Array.isArray(
                                                                      joinFilter.emptyInclude
                                                                    )
                                                                      ? _vm._i(
                                                                          joinFilter.emptyInclude,
                                                                          null
                                                                        ) > -1
                                                                      : joinFilter.emptyInclude,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      var $$a =
                                                                          joinFilter.emptyInclude,
                                                                        $$el =
                                                                          $event.target,
                                                                        $$c =
                                                                          $$el.checked
                                                                            ? true
                                                                            : false
                                                                      if (
                                                                        Array.isArray(
                                                                          $$a
                                                                        )
                                                                      ) {
                                                                        var $$v =
                                                                            null,
                                                                          $$i =
                                                                            _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                        if (
                                                                          $$el.checked
                                                                        ) {
                                                                          $$i <
                                                                            0 &&
                                                                            _vm.$set(
                                                                              joinFilter,
                                                                              "emptyInclude",
                                                                              $$a.concat(
                                                                                [
                                                                                  $$v,
                                                                                ]
                                                                              )
                                                                            )
                                                                        } else {
                                                                          $$i >
                                                                            -1 &&
                                                                            _vm.$set(
                                                                              joinFilter,
                                                                              "emptyInclude",
                                                                              $$a
                                                                                .slice(
                                                                                  0,
                                                                                  $$i
                                                                                )
                                                                                .concat(
                                                                                  $$a.slice(
                                                                                    $$i +
                                                                                      1
                                                                                  )
                                                                                )
                                                                            )
                                                                        }
                                                                      } else {
                                                                        _vm.$set(
                                                                          joinFilter,
                                                                          "emptyInclude",
                                                                          $$c
                                                                        )
                                                                      }
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : filterField.fieldType == "liffUser"
                            ? _c("div", { staticClass: "col-6 ml-3 mr-3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card",
                                    staticStyle: { width: "100%" },
                                  },
                                  [
                                    _c("div", { staticClass: "card-body" }, [
                                      _c(
                                        "div",
                                        { staticClass: "card-header row" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-6 d-flex align-items-center",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("__enable")) +
                                                  " "
                                              ),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      filterField.liffUser
                                                        .enabled,
                                                    expression:
                                                      "filterField.liffUser.enabled",
                                                  },
                                                ],
                                                staticClass: "ml-2",
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    filterField.liffUser.enabled
                                                  )
                                                    ? _vm._i(
                                                        filterField.liffUser
                                                          .enabled,
                                                        null
                                                      ) > -1
                                                    : filterField.liffUser
                                                        .enabled,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        filterField.liffUser
                                                          .enabled,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            filterField.liffUser,
                                                            "enabled",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            filterField.liffUser,
                                                            "enabled",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        filterField.liffUser,
                                                        "enabled",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-6 d-flex align-items-center",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("__FilterField")
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        filterField.liffUser
                                                          .filterField,
                                                      expression:
                                                        "filterField.liffUser.filterField",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  on: {
                                                    change: function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        filterField.liffUser,
                                                        "filterField",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        value: "",
                                                        disabled: "",
                                                        selected: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "__UserVariableSelectOptional"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._l(
                                                    _vm.allVariables,
                                                    function (value, index) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key:
                                                            "variable-" + index,
                                                          domProps: {
                                                            value: value,
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(value))]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _c("div", { staticClass: "col-6 ml-3 mr-3" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: filterField.filterField,
                                        expression: "filterField.filterField",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          filterField,
                                          "filterField",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "",
                                          disabled: "",
                                          selected: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "__UserVariableSelectOptional"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.allVariables,
                                      function (value, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: "variable-" + index,
                                            domProps: { value: value },
                                          },
                                          [_vm._v(_vm._s(value))]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                          _c("div", { staticClass: "ml-1" }, [
                            _c(
                              "a",
                              {
                                staticClass: "text-danger m-1",
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteFilterFiled(findex, index)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-minus text-danger",
                                }),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "ml-1" }, [
                            index ==
                            formfiltersetting.filterFiledsObjectlize.length - 1
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "text-info m-1",
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addFilterFiled(findex)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-plus text-info",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }
                  ),
                  _c("div", { staticClass: "mt-4" }, [
                    _c("label", [
                      _c("b", [_vm._v(_vm._s(_vm.$t("條件式設定")))]),
                    ]),
                    _c(
                      "table",
                      { staticClass: "table table-bordered table-striped" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticStyle: { width: "60px" },
                                attrs: { scope: "col" },
                              },
                              [_vm._v("#")]
                            ),
                            _c(
                              "th",
                              {
                                staticStyle: { width: "160px" },
                                attrs: { scope: "col" },
                              },
                              [_vm._v("資料類型")]
                            ),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v("Variable"),
                            ]),
                            _c(
                              "th",
                              {
                                staticStyle: { width: "160px" },
                                attrs: { scope: "col" },
                              },
                              [_vm._v("條件")]
                            ),
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v("值"),
                            ]),
                            _c("th", {
                              staticStyle: { width: "60px" },
                              attrs: { scope: "col" },
                            }),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(
                              formfiltersetting.conditions,
                              function (cond, ci) {
                                return _c("tr", { key: "cond-row-" + ci }, [
                                  _c("td", [_vm._v(_vm._s(ci + 1))]),
                                  _c("td", [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: cond.dataType,
                                            expression: "cond.dataType",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              cond,
                                              "dataType",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { value: "", selected: "" },
                                          },
                                          [_vm._v("請選擇")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "input" } },
                                          [_vm._v("input")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "checkbox" } },
                                          [_vm._v("checkbox")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "radio" } },
                                          [_vm._v("radio")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("td", [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: cond.variable,
                                            expression: "cond.variable",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              cond,
                                              "variable",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "",
                                              disabled: "",
                                              selected: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "__UserVariableSelectOptional"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.allVariables,
                                          function (value, idx) {
                                            return _c(
                                              "option",
                                              {
                                                key:
                                                  "cond-var-" + ci + "-" + idx,
                                                domProps: { value: value },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(value) + " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                  _c("td", [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: cond.operator,
                                            expression: "cond.operator",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              cond,
                                              "operator",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { value: "", selected: "" },
                                          },
                                          [_vm._v("請選擇")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "moreThan" } },
                                          [_vm._v(">")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "equal" } },
                                          [_vm._v("==")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "lessThan" } },
                                          [_vm._v("<")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "notEqual" } },
                                          [_vm._v("!=")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: cond.value,
                                          expression: "cond.value",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text" },
                                      domProps: { value: cond.value },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            cond,
                                            "value",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                  _c("td", [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-outline-danger",
                                        attrs: {
                                          title: "刪除條件 " + (ci + 1),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteCondition(
                                              findex,
                                              ci
                                            )
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fa fa-minus" })]
                                    ),
                                    ci ===
                                    formfiltersetting.conditions.length - 1
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-outline-primary ml-1",
                                            attrs: { title: "新增條件" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addCondition(findex)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-plus",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ])
                              }
                            ),
                            !formfiltersetting.conditions ||
                            formfiltersetting.conditions.length === 0
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-center text-secondary",
                                      attrs: { colspan: "6" },
                                    },
                                    [
                                      _vm._v(" 請新增條件 "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-sm btn-outline-primary ml-2",
                                          attrs: { title: "新增條件" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addCondition(findex)
                                            },
                                          },
                                        },
                                        [_c("i", { staticClass: "fa fa-plus" })]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "row mb-2 align-items-center" }, [
                    _c("div", { staticClass: "row col-6 my-2" }, [
                      _c("p", { staticClass: "col-9 my-4" }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("__ShowField")))]),
                      ]),
                    ]),
                    _c("div", { staticClass: "ml-1" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-info m-1",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              return _vm.addShowFiled(findex)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-plus text-info" })]
                      ),
                    ]),
                  ]),
                  _vm._l(
                    formfiltersetting.showFiledsObjectlize,
                    function (showFiled, index) {
                      return _c(
                        "div",
                        { key: findex + "-show-" + index, staticClass: "row" },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: showFiled.userVariable,
                                  expression: "showFiled.userVariable",
                                },
                              ],
                              staticClass: "form-control col-6 ml-3 mr-3",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    showFiled,
                                    "userVariable",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "",
                                    disabled: "",
                                    selected: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("__UserVariableSelectOptional")
                                    )
                                  ),
                                ]
                              ),
                              _vm._l(_vm.allVariables, function (value, index) {
                                return _c(
                                  "option",
                                  {
                                    key: "variable-" + index,
                                    domProps: { value: value },
                                  },
                                  [_vm._v(_vm._s(value))]
                                )
                              }),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "ml-1" }, [
                            _c(
                              "a",
                              {
                                staticClass: "text-danger m-1",
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteShowFiled(findex, index)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-minus text-danger",
                                }),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "ml-1" }, [
                            index ==
                            formfiltersetting.showFiledsObjectlize.length - 1
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "text-info m-1",
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addShowFiled(findex)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-plus text-info",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }
                  ),
                ],
                2
              ),
            ])
          }),
          _c(
            "div",
            {
              staticClass: "row pt-4 add-btn-input cursor-pointer",
              on: {
                click: function ($event) {
                  return _vm.addFormFilterSetting()
                },
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "mx-auto my-3",
                  attrs: { href: "javascript:void(0)" },
                },
                [_c("i", { staticClass: "fas fa-plus" })]
              ),
            ]
          ),
        ],
        2
      ),
    ]),
    _c(
      "button",
      {
        staticClass: "btn btn-outline-success pull-right",
        attrs: { "data-translate": "" },
        on: {
          click: function ($event) {
            return _vm.updateFormScenarioFilterConfig()
          },
        },
      },
      [_vm._v(" Update ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }